import { render } from "./ActionsDefaults.vue?vue&type=template&id=88c37ce8&scoped=true"
import script from "./ActionsDefaults.vue?vue&type=script&lang=js"
export * from "./ActionsDefaults.vue?vue&type=script&lang=js"

import "./ActionsDefaults.vue?vue&type=style&index=0&id=88c37ce8&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88c37ce8"]])

export default __exports__